import React, { useContext } from 'react';
import styled from 'styled-components';
import { COMPONENT_MARGIN_BOTTOM } from '../../constants';
import { DesktopTabs } from './DesktopTabs';
import { NarrowTabs } from './NarrowTabs';
import media from '../../utils/media';
import { getFieldValue } from '../../utils/helpers';
import { BreakpointContext } from '../BreakpointProvider';
const Container = styled.section `
  min-height: 575px;
  margin-top: ${({ hasNegativeMarginTop }) => hasNegativeMarginTop ? `calc(-30px - ${COMPONENT_MARGIN_BOTTOM.DESKTOP}px)` : ''};
  margin-bottom: ${`${COMPONENT_MARGIN_BOTTOM.DESKTOP}px`};

  ${media.mobile} {
    margin-top: ${({ hasNegativeMarginTop }) => hasNegativeMarginTop ? `calc(-30px - ${COMPONENT_MARGIN_BOTTOM.MOBILE}px)` : ''};
    margin-bottom: ${`${COMPONENT_MARGIN_BOTTOM.MOBILE}px`};
  }
`;
// TODO: UNIT TESTS!!!
export const Tabs = ({ fields }) => {
    var _a;
    if (!fields || !fields.items) {
        console.warn('Tabs Component requires fields to be provided');
        return null;
    }
    const { items, ariaLabel, componentNegativeMargin } = fields;
    if (items.length <= 1) {
        console.warn('Tabs Component requires 2 or more items');
        return null;
    }
    const breakpoints = useContext(BreakpointContext);
    return (React.createElement(Container, { hasNegativeMarginTop: getFieldValue(componentNegativeMargin), "aria-label": ariaLabel && ariaLabel.value }, ((_a = breakpoints) === null || _a === void 0 ? void 0 : _a.isMobile) ? React.createElement(NarrowTabs, { items: items }) : React.createElement(DesktopTabs, { items: items })));
};
